import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import Styles from '../../assets/stylesheets/layout.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { DEFAULT_DATA_TABLE_ORDER, FORBIDDEN_STATUS_CODE, REPORT_PAGINATION } from '../../actions/constants';
import { getExamsList } from '../../actions/examsActions'
import { getTests } from '../../actions/testsActions';
import { generateCodificationProgressReportByExam, getCodificationProgressReportByExam, GET_CODIFICATION_PROGRESS_REPORT_BY_EXAM } from '../../actions/reportsActions';
import Select from 'react-select';
import ReportList from './ReportList';
import swal from 'sweetalert2';
import moment from 'moment/moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import IconTooltip from '../utils/IconTooltip';

export default function CodificationProgressReportByExam(props) {

  const dispatch = useDispatch()
  const exams = useSelector(state => state.exams.examList)
  const tests = useSelector(state => state.tests.tests)
  const report = useSelector(state => state.reports.codificationProgressReportByExam)
  const pagination = useSelector(state => state.reports.codificationProgressReportByExamPagination)

  const [options, setOptions] = useState({
    exams: [],
    tests: []
  })
  const [ form, setForm ] = useState({
    exam: null,
    tests: []
  })

  const handleChange = (e) => {
    if (e instanceof Array) {
      setForm({
        ...form,
        tests: e
      })
    } else {
      // Limpiar el reporte anterior
      if ($.fn.dataTable.isDataTable('#tblCodificationProgressReportByExam')){
        $('#tblCodificationProgressReportByExam').DataTable().destroy()
      }
      dispatch({
        type: GET_CODIFICATION_PROGRESS_REPORT_BY_EXAM,
        payload: { reportList: [], links: {} }
      })
      
      setForm({
        exam: e,
        tests: []
       })
    }
    
  }

  const generateReport = (event) => {
    event.preventDefault();
    swal({
      title: '¿Está seguro?',
      text: 'Se generará un nuevo reporte a la fecha',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        const successCallback = () => {
          swal({
            type: 'success',
            title: 'El reporte se está generando',
            showConfirmButton: false,
            timer: 1200
          });
        };

        const errorCallback = (error) => {
          console.log('Error overwriting the grade', error.request);
          if (error.request.status === FORBIDDEN_STATUS_CODE) {
            swal(
              'Ups...',
              `Ocurrió un error al tratar de generar el reporte`,
              'error'
            );
          } else {
            swal(
              'Ups...',
              'Ocurrió un error al tratar de generar el reporte',
              'error'
            );
          }
        };
        const data = {
          exam: form.exam.value,
          exam_test_option_id : form.tests.map(test => test.value).sort((test_1,test_2) => test_1 - test_2)
        }
        dispatch(generateCodificationProgressReportByExam(data, successCallback, errorCallback))
      }
    });
    
   
  }

  const reloadReport = () => {
    
    if ($.fn.dataTable.isDataTable('#tblCodificationProgressReportByExam')){
      $('#tblCodificationProgressReportByExam').DataTable().destroy()
    }

    const successCallback = () => {
      swal({
        type: 'success',
        showConfirmButton: false,
        timer: 1000
      });
     
      $('#tblCodificationProgressReportByExam').DataTable(DEFAULT_DATA_TABLE_ORDER)
    }

    const errorCallback = (error) => {
      console.log('Error creating the exam', error.request);
    }
    dispatch(getCodificationProgressReportByExam(form.exam.value, form.tests.map(test => test.value).sort((test_1,test_2) => test_1 - test_2), REPORT_PAGINATION, successCallback, errorCallback))
  }

  const onPaginateReport = (paginate) => {
    
    if ($.fn.dataTable.isDataTable('#tblCodificationProgressReportByExam')){
      $('#tblCodificationProgressReportByExam').DataTable().destroy()
    }

    const successCallback = () => {
      swal({
        type: 'success',
        showConfirmButton: false,
        timer: 1000
      });
     
      $('#tblCodificationProgressReportByExam').DataTable(DEFAULT_DATA_TABLE_ORDER)
    }

    const errorCallback = (error) => {
      console.log('Error creating the exam', error.request);
    }
    dispatch(getCodificationProgressReportByExam(form.exam.value, form.tests.map(test => test.value).sort((test_1,test_2) => test_1 - test_2), paginate, successCallback, errorCallback))
  }

  const downloadXls = (elementId, filename) => {
    const table_div = document.getElementById(elementId);

    const reporte = XLSX.utils.table_to_book(table_div, {sheet:"Reporte"});
    const archivo_reporte = XLSX.write(reporte, {bookType:'xlsx', bookSST:true, type: 'binary'});
    var buffer = new ArrayBuffer(archivo_reporte.length);
    var view = new Uint8Array(buffer);
    for (var i=0; i<archivo_reporte.length; i++) view[i] = archivo_reporte.charCodeAt(i) & 0xFF;

    saveAs(new Blob([buffer],{type:"application/octet-stream"}), filename);
  }

  const get_total_anulled = (status) => {
    let total=0
    if (status.anulled ){
      total += status.anulled
    }
    if (status.reassigned){
      total += status.reassigned
    }
    return total
  }

  const renderCodificationProgressReport = () => {
    const data = report.reportList[0]?.reportInfo
    
    if (report && data) {
      return (
        <div  className="table-responsive  col-xs-12">
            {data.reportData && data.reportData.length > 0?
                <>
                <ul className="list-group scrolling-list">
                  <table id="tblCodificationProgressReportByExam" className="table table-bordered dt-responsive table-striped">
                    <thead>
                      <tr>
                        <th>Examen</th>
                        <th>Codificador</th>
                        <th>Respuestas no empezadas</th>
                        <th>Pendientes de codificación</th>
                        <th>En revisión</th>
                        <th>Terminadas</th>
                        <th>Codificada por el revisor</th>
                        <th>Anuladas/reasignadas</th>
                        <th>Total asignadas</th>
                      </tr>
                    </thead>
                    <tbody>
                    {data.reportData.map((row, index) => {
                      return (
                          <tr key={index}>
                            <td>{row.examTitle}</td>
                            <td>{row.codifierEmail}</td>
                            <td>{row.onHold || 0}</td>
                            <td>{row.toDo || 0}</td>
                            <td>{row.inReview || 0}</td>
                            <td>{row.done || 0}</td>
                            <td>{row.doneR || 0}</td>
                            <td>{row.anulled || row.reassigned? get_total_anulled(row.status) : 0}</td>
                            <td>{row.totalAssigned || 0}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <p><strong>Total de registros: </strong>{data.totalRecords}</p>
                </ul>
                <div className="row">
                    <div className="col-md-12 col-xs-12">
                      <button
                        onClick={() => {
                          let fecha = new Date();
                          fecha = moment(fecha).format('D [de] MMMM [de] YYYY');
                          downloadXls("tblCodificationProgressReportByExam",
                          `reporte_avance_codificaciones_por_examen_${fecha}.xlsx`)
                        }}
                        type="button"
                        className="btn btn-default pull-right"
                      ><IconTooltip text="Descargar" icon="fa-download"/>
                      </button>
                    </div>
                </div>
                </>
            :
            <div className="row text-center">
                <h5>No hay datos disponibles</h5>
            </div>}
        </div>
      );
 
    }
  }
  
  
  useEffect(()=>{
    if (tests) {
      setOptions({
        ...options,
        tests: Object.values(tests).map(({examTestOptionId:value, title:label })=>({ value, label }))
      })
    }
  },[tests])

  useEffect(()=>{
    form.exam?.value && dispatch(getTests(`?exam=${form.exam.value}`))
  },[form.exam])

  useEffect(()=>{
    
    if (exams) {
     
      const examsSorted = Object.values(exams).sort((a, b) => b.id - a.id) 
      setOptions({
        ...options,
        exams: examsSorted.map(({id:value, title:label })=>({ value, label }))
      })
    }
  },[exams])

  useEffect(()=>{
    dispatch(getExamsList())
    // Limpiar el estado del reporte al montar el componente
    dispatch({
      type: GET_CODIFICATION_PROGRESS_REPORT_BY_EXAM,
      payload: { reportList: [], links: {} }
    })
    // Limpiar la DataTable si existe
    if ($.fn.dataTable.isDataTable('#tblCodificationProgressReportByExam')){
      $('#tblCodificationProgressReportByExam').DataTable().destroy()
    }
    // Limpiar el formulario
    setForm({
      exam: null,
      tests: []
    })
    
    return () => {
      if ($.fn.dataTable.isDataTable('#tblCodificationProgressReportByExam')){
        $('#tblCodificationProgressReportByExam').DataTable().destroy()
      }
    }
  },[])

  return (
    <div className={Styles.main}>
      <section>
        <div className='row'>
          <h1>Reporte de progreso de codificaciones por examen</h1>
          <p> A continuación, podrá generar un reporte de avance de codificaciones por examen. Para ello, seleccione un examen y las preguntas que desea incluir en el reporte.
          </p>
          <form id='generateReport' >
            <div className='col-sm-6'>
              <label htmlFor="participants">Exámen</label>
              <Select
                onChange={handleChange}
                value={form.exam || {}}
                placeholder="Seleccione un exámen"
                multi={false}
                options={options.exams} 
                required={true}
                inputId= "participants"
                id="participants"
                name="participants"
              />

            </div>
            {form.exam  && (
              <div className='col-sm-6'>
              <label htmlFor="participants">Preguntas</label>
              <Select
                onChange={handleChange}
                value={form.tests || {}}
                placeholder="Seleccione las preguntas"
                multi={true}
                options={options.tests} 
                required={true}
                inputId= "participants"
                id="participants"
                name="participants"
              />
              </div>

            )}
            </form>
          </div>
          {(form.exam && form.tests.length > 0) && (
            <ReportList reports={report ? report: {reportList: []}}
              reportType= 'estados de codificaciones'
              pagination = {pagination}
              onReloadReport = {reloadReport}
              onPaginateReport={onPaginateReport}
              onGenerateReportSubmit ={generateReport}
              onChangeDefaultReport ={reloadReport}
              description="En este reporte puede ver los estados de las codificaciones por examen">
            </ReportList>
          ) }
          { report && report.reportList.length!==0 && 
            renderCodificationProgressReport()
          }
      </section>
      <section 
				style={{
					display: 'flex',
					alignItems: 'center',
					flexFlow: 'row nowrap',
					justifyContent: 'space-between',
				}}
			>
				<button
					onClick={() => props.history.push(`/`)}
					type="button"
					className="btn btn-danger">
					Volver
				</button>
			</section>

    </div>
  )
}

